<template>
  <div class="grid__cell col7-of-12--large-up">
    <p class="fw-bold fs-md mb-xs">Full customization</p>
    <p class="fs-sm fc-darker mb-lg">
      You can fully adapt your directory to your current website by adding
      custom HTML and CSS. Just add the HTML markup of both header and footer
      and the CSS styles associated to each one.
    </p>
    <CodeFormEditor
      :code="data.customHeader"
      @input="codeChange"
      name="customHeader"
      label="Header HTML"
    />
    <CodeFormEditor
      :code="data.customFooter"
      @input="codeChange"
      name="customFooter"
      label="Footer HTML"
    />
    <CodeFormEditor
      :code="data.customFirstSection"
      @input="codeChange"
      name="customFirstSection"
      label="First section HTML"
    />
    <CodeFormEditor
      :code="data.customLastSection"
      @input="codeChange"
      name="customLastSection"
      label="Last section HTML"
    />
    <CodeFormEditor
      :code="data.customIntegrationSection"
      @input="codeChange"
      name="customIntegrationSection"
      label="Integration section HTML"
    />
    <CodeFormEditor
      :code="data.customCss"
      @input="codeChange"
      name="customCss"
      modeType="text/css"
      label="Custom CSS"
      placeholder="You can add any namespace. This CSS won't collide with the base one."
    />
    <CodeFormEditor
      :code="data.customJs"
      @input="codeChange"
      name="customJs"
      modeType="text/javascript"
      label="Custom JS"
      placeholder="You can add multiple scripts here. DO NOT include <script></script> tags."
    />
  </div>
</template>

<script>
import CodeFormEditor from '@/components/DesignSystem/Inputs/CodeFormEditor';

export default {
  components: { CodeFormEditor },
  props: {
    data: Object,
  },
  methods: {
    codeChange(payload) {
      this.$emit('code-change', payload);
    },
  },
};
</script>
